import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SvgUtility } from '~/ui/utils';

import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './controls.styles';

import { DERElement } from '~/common/der-element';
import { DerVariant, Direction } from './enum';

export class Controls extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    constructor() {
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true,
        });
    }

    @property({ type: Boolean }) disabled = false;
    @property({ type: String }) variant: DerVariant = DerVariant.Default;
    @property({ type: String }) direction: Direction = Direction.Right;
    @property({ type: Number }) override tabIndex = 0;

    private onClick = (e: MouseEvent) => {
        if (this.disabled) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }

        this.dispatchEvent(
            new CustomEvent('der.click', {
                bubbles: true,
                composed: true,
                detail: { direction: this.direction },
            })
        );
    };

    private getIcon() {
        const isReduced = this.variant === DerVariant.Reduced || this.variant === DerVariant.ReducedInverted;

        if (this.direction === Direction.Left) {
            return isReduced ? SvgUtility.systemChevronLeft : SvgUtility.systemArrowLeftLong;
        } else {
            return isReduced ? SvgUtility.systemChevronRight : SvgUtility.systemArrowRightLong;
        }
    }

    override render() {
        return html`
            <button
                class=${classMap({
                    'c-controls__control-item': true,
                    disabled: this.disabled,
                    reduced: this.variant === DerVariant.Reduced,
                    'default-inverted': this.variant === DerVariant.DefaultInverted,
                    'reduced-inverted': this.variant === DerVariant.ReducedInverted,
                })}
                tabindex=${this.tabIndex}
                aria-disabled=${this.disabled ? 'true' : 'false'}
                ?disabled=${this.disabled}
                @click=${this.onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">${this.getIcon()}</svg>
            </button>
        `;
    }
}
